import type { IconNode } from '../types';

/**
 * @name sushi-2
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYuNCAzLjNhOC4yMyA4LjIzIDAgMCAwLTguOCAwTDMuOCA2Yy0yLjQgMS43LTIuNCA0LjQgMCA2LjFsMy45IDIuN2MyLjQgMS43IDYuMyAxLjcgOC43IDBsMy45LTIuN2MyLjQtMS43IDIuNC00LjQgMC02LjFaIiAvPgogIDxwYXRoIGQ9Ik0yIDl2NmMwIDEuMS42IDIuMiAxLjggM2wzLjkgMi43YzIuNCAxLjcgNi4zIDEuNyA4LjcgMGwzLjktMi43YzEuMi0uOCAxLjgtMS45IDEuOC0zVjkiIC8+CiAgPHBhdGggZD0iTTcuNyAxMC4xYy0uOS0uNi0uOS0xLjYgMC0yLjJsMi43LTEuOGMuOS0uNiAyLjQtLjYgMy4zIDBsMi43IDEuOGMuOS42LjkgMS42IDAgMi4ybC0yLjcgMS44Yy0uOS42LTIuNC42LTMuMyAwWiIgLz4KICA8cGF0aCBkPSJNMTUgMTFjLTItMy01LTItNiAwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/sushi-2
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const sushi2: IconNode = [
  [
    'path',
    {
      d: 'M16.4 3.3a8.23 8.23 0 0 0-8.8 0L3.8 6c-2.4 1.7-2.4 4.4 0 6.1l3.9 2.7c2.4 1.7 6.3 1.7 8.7 0l3.9-2.7c2.4-1.7 2.4-4.4 0-6.1Z',
      key: 'hqq7v6',
    },
  ],
  [
    'path',
    {
      d: 'M2 9v6c0 1.1.6 2.2 1.8 3l3.9 2.7c2.4 1.7 6.3 1.7 8.7 0l3.9-2.7c1.2-.8 1.8-1.9 1.8-3V9',
      key: '1y7lr8',
    },
  ],
  [
    'path',
    {
      d: 'M7.7 10.1c-.9-.6-.9-1.6 0-2.2l2.7-1.8c.9-.6 2.4-.6 3.3 0l2.7 1.8c.9.6.9 1.6 0 2.2l-2.7 1.8c-.9.6-2.4.6-3.3 0Z',
      key: 'nevgot',
    },
  ],
  ['path', { d: 'M15 11c-2-3-5-2-6 0', key: '1rc499' }],
];

export default sushi2;
